const mEditionMapPathModalCreatePath = {
  mEditionMapPathModalCreatePath: {
    alerts: {
      createContenidoNodo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El nuevo camino fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 255 caracteres'
      }
    },

    title: 'Nuevo Camino',

    validation: {
      nodo: {
        nombre: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de camino es requerido.'
        }
      }
    }
  }
}

export default mEditionMapPathModalCreatePath
